import cognitivePaper from '../../../media/papers/cognitive_partner/Cognitive_Partner1.pdf';
import ai_gen from '../../../media/papers/cognitive_partner/ai_gen.png';

const cognitivePartnerData = {
    name: "AI as a Cognitive Partner",
    category: "Artificial Intelligence",
    tagline: "Redefining Large Language Models as partners in distributed cognition and extended mind theory",
    year: "2025",
    heroImage: ai_gen,

    description: "Large language models are often framed as automation tools, but in practice they are frequently used as interactive collaborators in reasoning and problem exploration. This paper argues that LLMs function as cognitive partners by enabling users to externalize thought processes into iterative dialogue. We describe a methodology based on maximal contextual input, unfiltered reasoning, and recursive conversational expansion, and connect it to distributed cognition and extended mind theory. The analysis addresses both the shift in how cognition is organized in practice and significant limitations, including hallucination risk, authority bias, and open questions about machine understanding.",

    techStack: [
        "Artificial Intelligence",
        "Human-Computer Interaction",
        "Psychology"
    ],

    documents: [
        { type: 'pdf', src: cognitivePaper, title: 'Read Research Paper' }
    ],
    documentTitle: "Paper"
};

export default cognitivePartnerData;
